/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';

export default class IndexRoute extends Route {
  queryParams = {
    offset: {
      refreshModel: true,
    },
    authorId: {
      refreshModel: true,
    },
    groupId: {
      refreshModel: true,
    },
    searchQuery: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    let offset = 0;
    if (!isEmpty(params.offset)) {
      let temp = Number(params.offset);
      if (!Number.isNaN(temp) && temp > 0) {
        offset = temp;
      }
    }
    let authorId = '';
    if (!isEmpty(params.authorId)) {
      authorId = params.authorId;
    }
    let groupId = '';
    if (!isEmpty(params.groupId)) {
      groupId = params.groupId;
    }
    let searchQuery = '';
    if (!isEmpty(params.searchQuery)) {
      searchQuery = params.searchQuery;
    }
    return this.store.query('posts/studentnotice', {
      perPage: 20,
      offset,
      authorId,
      groupId,
      searchQuery,
      include: 'reactions,comments',
    });
  }
}
